import React, { Component } from 'react'
import './css.css';
import Web3 from 'web3';
import ShopToken from '../Ticket1_0/ShopToken'
import FreeToken from '../Freebies1_0/FreeToken'
import ShopPair from '../PairSwapper1_0/ShopPair'
import utils from '../../library'

class GhostContainer extends Component {
constructor(props){
  super(props)
  this.state={favoriteProducts:[]}
}

    componentDidMount(){
     this.loadFaves()
    }

async loadFaves(){
  
    let final=[]
        if(this.props.ticketCode==4)final.push(<ShopToken ghost={this.props.ghost} db={this.props.db} priceList={this.props.priceList} address={this.props.address} price={this.props.price} index={this.props.index} ticket={this.props.ticket} edit={this.props.edit} name={this.props.name}></ShopToken>);
        if(this.props.ticketCode==7)final.push(<FreeToken ghost={this.props.ghost} db={this.props.db} priceList={this.props.priceList} address={this.props.address} price={this.props.price} index={this.props.index} ticket={this.props.ticket} edit={this.props.edit} name={this.props.name}></FreeToken>);
        if(this.props.ticketCode==9)final.push(<ShopPair ghost={this.props.ghost}  db={this.props.db} priceList={this.props.priceList} address={this.props.address} price={this.props.price} index={this.props.index} ticket={this.props.ticket} edit={this.props.edit} name={this.props.name}></ShopPair>);
  this.setState({favoriteProducts:final})
}

   
setCookie(){
  console.log(this.props)
  if(this.props.ghost==true){
    let Tindex=this.props.index.substring(0,this.props.index.lastIndexOf("y"))+this.props.index.substring(this.props.index.lastIndexOf("y")+1,this.props.index.length)
  utils.setCookie("ghost",this.props.address,Tindex)
  }else{
  utils.setCookie("ghost",this.props.address,this.props.index)}
  this.props.reload()
}
  
    render(){
        console.log(this.props.update) 
        return ( 
        <div>
          <div id={"ghost_"+this.props.index} favorite={this.props.ghost} className={(this.props.ghost==true)?"ghost_favorite":"ghost_notfavorite"} onClick={() => this.setCookie()}>👻</div>
          <div className="fav_container">{this.state.favoriteProducts}</div>
        </div>
        );
    }


}


const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")

export default GhostContainer